module.exports = __webpack_public_path__ + "img/professor-richard-so.e4758cb1.png";